import { blueGrey } from '@material-ui/core/colors';

const styles = (theme) => ({
  root: {
    flexGrow: 1,
  },
  fab: {
    position: 'fixed',
    bottom: theme.spacing(10),
    right: theme.spacing(6),
  },
  blue: {
    color: theme.palette.getContrastText(blueGrey[500]),
    backgroundColor: blueGrey[500],
    fontFamily: ['Roboto'],
  },
  marginTop: {
    marginTop: '24px',
  },
  filterButton: {
    marginTop: '16px',
  },
  greenChip: {
    backgroundColor: theme.palette.primary.light,
    marginRight: '8px',
    maxWidth: '100%',
    width: 'fit-content',
    '& .MuiChip-label': {
      whiteSpace: 'nowrap',
      overflow: 'visible',
      textOverflow: 'clip',
    },
  },
  blueChip: {
    backgroundColor: theme.palette.info.light,
    marginRight: '8px',
    maxWidth: '100%',
    width: 'fit-content',
    '& .MuiChip-label': {
      whiteSpace: 'nowrap',
      overflow: 'visible',
      textOverflow: 'clip',
    },
  },
  redChip: {
    backgroundColor: theme.palette.error.light,
    marginRight: '24px',
    maxWidth: '100%',
    width: 'fit-content',
    '& .MuiChip-label': {
      whiteSpace: 'nowrap',
      overflow: 'visible',
      textOverflow: 'clip',
    },
  },
  tableViewport: {
    width: '100%',
    overflowX: 'auto',
    overflowY: 'hidden',
    '@media (max-width: 1200px)': {
      overflowX: 'hidden',
    },
  },
  tableCanvas: {
    minWidth: 1670,
    '@media (max-width: 1200px)': {
      minWidth: '100%',
    },
  },
  labelItem: {
    ...theme.typography.button,
    backgroundColor: theme.palette.primary.light,
    color: theme.palette.info.contrastText,
    padding: theme.spacing(1),
    borderRadius: theme.shape.borderRadius,
    textAlign: 'center',
    width: 100,
  },
});

export default styles;
